import { styled, makeStyles } from '@material-ui/core/styles';
import { Box, Paper } from '@material-ui/core';

export const Container = styled(Box)({
  width: '100%',
});

export const CardsRow = styled(Box)({
  display: 'flex',
  gap: '16px',
  marginBottom: '24px',
  flexWrap: 'wrap',
});

export const StatCard = styled(Paper)({
  padding: '20px',
  minWidth: '180px',
  flex: 1,
});

export const useStyles = makeStyles(theme => ({
  cardTitle: {
    fontSize: '13px',
    color: theme.colors.whiteWeak,
    marginBottom: '4px',
  },
  cardValue: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#fff',
  },
  tableContainer: {
    background: theme.colors.backgroundLight,
    borderRadius: theme.borderRadius,
    padding: '16px',
  },
  sectionTitle: {
    fontSize: '18px',
    marginBottom: '12px',
    color: '#fff',
  },
}));
